export default __webpack_public_path__ + "static/image-fallback-3f9839748f63243e9e284f8c3b1f1918.jpg";